/* ═══════════════════════════════════════════════════════════════
   LC MARKET — Shopify glue
   Ajax cart · sticky buy · variant select · tweak persistence
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(0);
    }
  };

  /* ─── AJAX CART ─── */
  async function cartGet() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  async function cartAdd(form) {
    const fd = new FormData(form);
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }

  async function cartChange(line, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    return r.json();
  }

  function renderCart(cart) {
    const body = $('[data-cart-body]');
    const total = $('[data-cart-total]');
    const count = $('[data-cart-count]');

    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = formatMoney(cart.total_price);

    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p style="text-align:center;padding:40px 0;color:var(--muted)">Tu carrito está vacío.</p>';
      return;
    }

    body.innerHTML = cart.items.map((it, i) => `
      <div class="cart-item" data-line="${i + 1}">
        <img src="${it.image ? it.image.replace(/\.(jpg|png|webp)/i, '_120x.$1') : ''}" alt="" loading="lazy">
        <div class="cart-item__info">
          <strong>${it.product_title}</strong>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<small>${it.variant_title}</small>` : ''}
          <div class="cart-item__qty">
            <button type="button" data-qty-down>−</button>
            <span>${it.quantity}</span>
            <button type="button" data-qty-up>+</button>
            <button type="button" data-remove style="margin-left:auto">Quitar</button>
          </div>
        </div>
        <div class="cart-item__price">${formatMoney(it.final_line_price)}</div>
      </div>
    `).join('');

    $$('.cart-item', body).forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      const item = cart.items[line - 1];
      row.querySelector('[data-qty-down]')?.addEventListener('click', async () => {
        const c = await cartChange(line, item.quantity - 1); renderCart(c);
      });
      row.querySelector('[data-qty-up]')?.addEventListener('click', async () => {
        const c = await cartChange(line, item.quantity + 1); renderCart(c);
      });
      row.querySelector('[data-remove]')?.addEventListener('click', async () => {
        const c = await cartChange(line, 0); renderCart(c);
      });
    });
  }

  function openCart() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-overlay');
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if(!/iPhone|iPad|iPod/.test(navigator.userAgent))document.body.style.overflow='hidden';
    cartGet().then(renderCart);
  }
  function closeCart() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow='';
  }

  $$('[data-open-cart]').forEach((b) => b.addEventListener('click', openCart));
  $$('[data-close-cart]').forEach((b) => b.addEventListener('click', closeCart));

  /* ─── ADD TO CART (intercept submit) ─── */
  $$('[data-add-to-cart-shopify]').forEach((btn) => {
    const form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const orig = btn.querySelector('span')?.textContent;
      btn.disabled = true;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Agregando…';
      try {
        await cartAdd(form);
        const c = await cartGet();
        renderCart(c);
        openCart();
        if (btn.querySelector('span')) btn.querySelector('span').textContent = '¡Agregado! ✓';
        setTimeout(() => { if (btn.querySelector('span')) btn.querySelector('span').textContent = orig || 'Lo quiero ya'; btn.disabled = false; }, 1400);
      } catch (err) {
        console.error(err);
        if (btn.querySelector('span')) btn.querySelector('span').textContent = orig || 'Error';
        btn.disabled = false;
      }
    });
  });

  /* ─── INITIAL CART RENDER ─── */
  cartGet().then(renderCart).catch(() => {});

  /* ─── TWEAKS PERSIST ─── */
  const html = document.documentElement;
  const TWEAK_KEY = 'lc:tweaks';
  let tw = {};
  try { tw = JSON.parse(localStorage.getItem(TWEAK_KEY) || '{}'); } catch {}
  if (tw.theme) html.dataset.theme = tw.theme;
  if (tw.heroFont) html.dataset.heroFont = tw.heroFont;
  if (tw.density) html.dataset.density = tw.density;

  $$('[data-tweak]').forEach((b) => {
    b.addEventListener('click', () => {
      const k = b.dataset.tweak, v = b.dataset.value;
      if (k === 'theme') { html.dataset.theme = v; tw.theme = v; }
      if (k === 'hero-font') { html.dataset.heroFont = v; tw.heroFont = v; }
      if (k === 'density') { html.dataset.density = v; tw.density = v; }
      $$(`[data-tweak="${k}"]`).forEach((x) => x.classList.toggle('is-active', x.dataset.value === v));
      localStorage.setItem(TWEAK_KEY, JSON.stringify(tw));
    });
  });

  $('.tweaks-toggle')?.addEventListener('click', () => document.body.classList.toggle('is-tweaks-open'));
  $('.tweaks__close')?.addEventListener('click', () => document.body.classList.remove('is-tweaks-open'));

  /* ─── STICKY BUY VISIBILITY (after scrolling past hero) ─── */
  const sticky = $('[data-sticky-buy]');
  if (sticky) {
    const hero = $('#hero');
    const onScroll = () => {
      if (!hero) return;
      const r = hero.getBoundingClientRect();
      sticky.classList.toggle('is-visible', r.bottom < 0);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── NAV DRAWER ─── */
  $$('[data-open-nav]').forEach((b) => b.addEventListener('click', () => document.body.classList.add('is-nav-open')));
  $$('[data-close-nav]').forEach((b) => b.addEventListener('click', () => document.body.classList.remove('is-nav-open')));
})();
